import { db, functions } from '@/firebase'

export default {
    getTicketsAbiertosFreshdesk({ commit }) {
        var get = functions.httpsCallable('httpFreshdeskGetOpenTickets');
        return get().then(r => {
            console.log(r);
            commit('setTicketsAbiertos', !!r && !!r.data ? r.data : [])
        })
    }
}